(function () {
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Reading direction drives the horizontal controls: in RTL, "next" lives on
  // the left and a leftward swipe moves backwards.
  function isRtl(node) {
    if (node && window.getComputedStyle) {
      var dir = window.getComputedStyle(node).direction;
      if (dir) return dir === 'rtl';
    }
    return document.documentElement.getAttribute('dir') === 'rtl';
  }

  /* ----------------------------------------------------------------------
   * Header + mobile drawer (single source of truth for drawer state).
   * Opens/closes, traps focus, closes on Escape, restores previous focus.
   * -------------------------------------------------------------------- */
  function initHero(root) {
    if (!root || root.dataset.aq24HeroInit) return;
    root.dataset.aq24HeroInit = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-aq24-hero-slide]'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-aq24-hero-dot]'));
    var prev = root.querySelector('[data-aq24-hero-prev]');
    var next = root.querySelector('[data-aq24-hero-next]');
    var index = 0;
    var timer = null;

    function show(target) {
      index = (target + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
        slide.querySelectorAll('a,button').forEach(function (el) {
          if (active) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '-1');
        });
      });
      dots.forEach(function (dot, i) {
        var current = i === index;
        dot.classList.toggle('is-active', current);
        if (current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
        dot.setAttribute('tabindex', current ? '0' : '-1');
      });
    }

    if (prev) prev.addEventListener('click', function () { stop(); show(index - 1); });
    if (next) next.addEventListener('click', function () { stop(); show(index + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stop();
        show(parseInt(dot.getAttribute('data-index') || '0', 10));
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      // Arrow keys belong to the focused control when focus is on a link,
      // button or field inside a slide - only the region itself steers slides.
      var t = event.target;
      if (t && t !== root && t.closest && t.closest('[data-aq24-hero-slide]')) {
        if (t.closest('a,button,input,select,textarea')) return;
      }
      var back = event.key === 'ArrowLeft';
      if (isRtl(root)) back = !back;
      event.preventDefault();
      stop();
      show(back ? index - 1 : index + 1);
    });

    var dotList = root.querySelector('.aq24-hero__dots');
    if (dotList) {
      dotList.addEventListener('keydown', function (event) {
        var key = event.key;
        var target = null;
        if (key === 'ArrowLeft' || key === 'ArrowRight') {
          var back = key === 'ArrowLeft';
          if (isRtl(root)) back = !back;
          target = (index + (back ? -1 : 1) + slidesLength()) % slidesLength();
        } else if (key === 'Home') {
          target = 0;
        } else if (key === 'End') {
          target = slidesLength() - 1;
        } else {
          return;
        }
        // Handled here: stop the region handler from advancing a second time
        // and stop the browser from scrolling the page.
        event.preventDefault();
        event.stopPropagation();
        stop();
        show(target);
        if (dots[index]) dots[index].focus();
      });
    }

    function slidesLength() { return slides.length; }

    var startX = null;
    var startY = null;
    var viewport = root.querySelector('[data-aq24-hero-viewport]') || root;
    viewport.addEventListener('touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    viewport.addEventListener('touchend', function (event) {
      if (startX === null) return;
      if (!event.changedTouches || !event.changedTouches.length) {
        startX = null;
        startY = null;
        return;
      }
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
        var forward = dx < 0;
        if (isRtl(root)) forward = !forward;
        stop();
        show(forward ? index + 1 : index - 1);
      }
      startX = null;
      startY = null;
    }, { passive: true });
    viewport.addEventListener('touchcancel', function () {
      startX = null;
      startY = null;
    }, { passive: true });

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      var seconds = parseInt(root.dataset.autoplay || '0', 10);
      if (!seconds || prefersReducedMotion()) return;
      if (root.contains(document.activeElement)) return;
      stop();
      timer = setInterval(function () {
        if (document.visibilityState === 'visible') show(index + 1);
      }, seconds * 1000);
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('focusin', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) start();
    });

    show(0);
    start();
  }

  /* ---------------------------------------------------------------------- */
  function initSolutions(root) {
    if (!root || root.dataset.aq24SolutionsInit) return;
    root.dataset.aq24SolutionsInit = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-aq24-solution-slide]'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-aq24-solution-dot]'));
    var viewport = root.querySelector('[data-aq24-solutions-viewport]') || root;
    var index = 0;
    var timer = null;
    var startX = null;
    var startY = null;

    function show(target) {
      index = (target + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelectorAll('a,button').forEach(function (el) {
          el.setAttribute('tabindex', active ? '0' : '-1');
        });
      });
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('tabindex', active ? '0' : '-1');
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      var seconds = parseInt(root.dataset.autoplay || '0', 10);
      if (!seconds || prefersReducedMotion() || root.contains(document.activeElement)) return;
      stop();
      timer = setInterval(function () {
        if (document.visibilityState === 'visible') show(index + 1);
      }, seconds * 1000);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stop();
        show(parseInt(dot.getAttribute('data-index') || '0', 10));
      });
    });
    viewport.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
      if (event.target && event.target.closest && event.target.closest('a,input,select,textarea')) return;
      event.preventDefault();
      stop();
      if (event.key === 'Home') show(0);
      else if (event.key === 'End') show(slides.length - 1);
      else {
        var back = event.key === 'ArrowLeft';
        if (isRtl(root)) back = !back;
        show(index + (back ? -1 : 1));
      }
      if (dots[index] && event.target.closest('[data-aq24-solution-dot]')) dots[index].focus();
    });
    viewport.addEventListener('touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    viewport.addEventListener('touchend', function (event) {
      if (startX === null) return;
      if (!event.changedTouches || !event.changedTouches.length) {
        startX = null;
        startY = null;
        return;
      }
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
        var forward = dx < 0;
        if (isRtl(root)) forward = !forward;
        stop();
        show(index + (forward ? 1 : -1));
      }
      startX = null;
      startY = null;
    }, { passive: true });
    viewport.addEventListener('touchcancel', function () {
      startX = null;
      startY = null;
    }, { passive: true });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('focusin', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) start();
    });
    show(0);
    start();
  }

  /* ---------------------------------------------------------------------- */
  function initQuotes(root) {
    if (!root || root.dataset.aq24QuoteInit) return;
    root.dataset.aq24QuoteInit = '1';
    var slides = [].slice.call(root.querySelectorAll('[data-aq24-quote]'));
    if (slides.length < 2) return;
    var idx = 0;
    var dots = [].slice.call(root.querySelectorAll('[data-aq24-dot]'));
    var timer = null;
    function show(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var active = i === idx;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (d, i) {
        var active = i === idx;
        d.classList.toggle('is-active', active);
        d.setAttribute('tabindex', active ? '0' : '-1');
        if (active) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }
    var p = root.querySelector('[data-aq24-prev]');
    var n = root.querySelector('[data-aq24-next]');
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function start() {
      var delay = parseInt(root.dataset.autoplay || '0', 10);
      if (!delay || prefersReducedMotion() || root.contains(document.activeElement)) return;
      stop();
      timer = setInterval(function () {
        if (document.visibilityState === 'visible') show(idx + 1);
      }, delay * 1000);
    }
    if (p) p.addEventListener('click', function () { stop(); show(idx - 1); });
    if (n) n.addEventListener('click', function () { stop(); show(idx + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        stop();
        show(parseInt(d.getAttribute('data-index') || '0', 10));
      });
    });
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
      if (event.target && event.target.closest && event.target.closest('a,input,select,textarea')) return;
      event.preventDefault();
      stop();
      if (event.key === 'Home') show(0);
      else if (event.key === 'End') show(slides.length - 1);
      else {
        var back = event.key === 'ArrowLeft';
        if (isRtl(root)) back = !back;
        show(idx + (back ? -1 : 1));
      }
      if (dots[idx] && event.target.closest('[data-aq24-dot]')) dots[idx].focus();
    });
    var startX = null;
    var startY = null;
    var box = root.querySelector('.aq24-quotes__box') || root;
    box.addEventListener('touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    box.addEventListener('touchend', function (event) {
      if (startX === null) return;
      if (!event.changedTouches || !event.changedTouches.length) {
        startX = null;
        startY = null;
        return;
      }
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
        var forward = dx < 0;
        if (isRtl(root)) forward = !forward;
        stop();
        show(idx + (forward ? 1 : -1));
      }
      startX = null;
      startY = null;
    }, { passive: true });
    box.addEventListener('touchcancel', function () {
      startX = null;
      startY = null;
    }, { passive: true });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('focusin', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) start();
    });
    show(0);
    start();
  }

  /* ----------------------------------------------------------------------
   * Mobile blog scroller: keep the visual thumb aligned to scroll progress.
   * -------------------------------------------------------------------- */
  function initBlogScrollbar(root) {
    if (!root || root.dataset.aq24BlogScrollbarInit) return;
    root.dataset.aq24BlogScrollbarInit = '1';

    var grid = root.querySelector('.aq24-blog__grid');
    var bar = root.querySelector('.aq24-blog__scrollbar');
    var track = root.querySelector('.aq24-blog__scrollbar-track');
    if (!grid || !bar || !track) return;

    var frame = null;
    var observer = null;
    var rtlStart = isRtl(grid) ? grid.scrollLeft : 0;

    function progress(maxScroll) {
      var raw = grid.scrollLeft;
      if (!isRtl(grid)) return raw / maxScroll;
      if (raw < 0) return -raw / maxScroll;
      if (rtlStart > 0) return (rtlStart - raw) / maxScroll;
      return raw / maxScroll;
    }

    function update() {
      frame = null;
      if (!root.isConnected) {
        grid.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        if (observer) observer.disconnect();
        return;
      }

      var maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
      var travel = Math.max(0, bar.clientWidth - track.offsetWidth);
      var value = maxScroll ? progress(maxScroll) : 0;
      value = Math.max(0, Math.min(1, value));
      var position = travel * (isRtl(grid) ? 1 - value : value);
      track.style.transform = 'translate3d(' + position + 'px,0,0)';
    }

    function schedule() {
      if (frame === null) frame = window.requestAnimationFrame(update);
    }

    grid.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(schedule);
      observer.observe(grid);
      observer.observe(bar);
    }
    schedule();
  }

  function initVideo(root) {
    if (!root || root.dataset.aq24VideoInit) return;
    root.dataset.aq24VideoInit = '1';
    var btn = root.querySelector('[data-aq24-play]');
    var vid = root.querySelector('video');
    if (!btn || !vid) return;
    btn.addEventListener('click', function () {
      if (vid.paused) { vid.play(); btn.hidden = true; } else { vid.pause(); btn.hidden = false; }
    });
    vid.addEventListener('pause', function () { btn.hidden = false; });
    vid.addEventListener('play', function () { btn.hidden = true; });
  }

  function init(scope) {
    var node = scope || document;
    node.querySelectorAll('[data-aq24-hero]').forEach(initHero);
    node.querySelectorAll('[data-aq24-solutions]').forEach(initSolutions);
    node.querySelectorAll('[data-aq24-quotes]').forEach(initQuotes);
    node.querySelectorAll('.aq24-blog').forEach(initBlogScrollbar);
    node.querySelectorAll('[data-aq24-video]').forEach(initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

